/**
 * Shared web typography tokens.
 * The primary font is loaded in public/index.html and exposed as
 * --font-primary in index.css. Always reference FONT_PRIMARY / FONT_WEIGHT
 * here instead of hardcoding font-family strings or numeric weights in
 * components — this is the single place to swap fonts or adjust weights
 * across the whole web app.
 *
 * Currently: Manrope — https://fonts.google.com/specimen/Manrope
 */
export const FONT_PRIMARY = 'var(--font-primary)';

export const FONT_WEIGHT = Object.freeze({
  extraLight: 200,
  light: 300,
  regular: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extraBold: 800,
});
